/**
 * Sistema completo de sincronización de variantes, imágenes y precios
 * Maneja productos importados con pricing min-max y múltiples opciones
 * Soluciona el problema de desincronización entre imágenes e inputs
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    
    const variantJson = document.querySelector('[data-variant-json]');
    if (!variantJson) return;

    let variants = [];
    let currentProduct = null;
    
    try {
      variants = JSON.parse(variantJson.textContent);
      
      // Obtener información del producto del DOM
      const productSection = document.querySelector('[data-section-type="product"]');
      if (productSection) {
        currentProduct = {
          id: productSection.dataset.currentProductId,
          handle: productSection.dataset.productHandle
        };
      }
    } catch (e) {
      console.warn('Error parsing variant JSON:', e);
      return;
    }

    // Función para formatear precio con moneda
    function formatPrice(price) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(price);
      }
      return '$' + (price / 100).toFixed(2);
    }

    // Función para encontrar variante basada en todas las opciones seleccionadas
    function findVariantByOptions() {
      const allSelects = document.querySelectorAll('select[name*="options"]');
      const selectedOptions = Array.from(allSelects).map(select => select.value);
      
      return variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
    }

    // Función para encontrar variante por imagen
    function findVariantByImage(mediaSrc) {
      if (!mediaSrc) return null;
      
      const mediaFileName = mediaSrc.split('/').pop().split('?')[0];
      
      return variants.find(variant => {
        if (variant.featured_image && variant.featured_image.src) {
          const variantFileName = variant.featured_image.src.split('/').pop().split('?')[0];
          return variantFileName === mediaFileName;
        }
        return false;
      });
    }

    // Función inteligente para encontrar variante respetando opciones seleccionadas
    function findCompatibleVariantForImage(mediaSrc) {
      if (!mediaSrc) return null;
      
      const mediaFileName = mediaSrc.split('/').pop().split('?')[0];
      
      // Obtener opciones actualmente seleccionadas
      const allSelects = document.querySelectorAll('select[name*="options"]');
      const currentSelectedOptions = Array.from(allSelects).map(select => select.value);
      
      // Primero: buscar variantes que tengan esta imagen
      const imageVariants = variants.filter(variant => {
        if (variant.featured_image && variant.featured_image.src) {
          const variantFileName = variant.featured_image.src.split('/').pop().split('?')[0];
          return variantFileName === mediaFileName && variant.available;
        }
        return false;
      });
      
      if (imageVariants.length === 0) return null;
      
      // Segundo: intentar encontrar variante que respete las opciones actuales
      const perfectMatch = imageVariants.find(variant => {
        return variant.options.every((option, index) => {
          // Si no hay opción seleccionada aún, aceptar cualquiera
          if (!currentSelectedOptions[index]) return true;
          // Si hay opción seleccionada, debe coincidir
          return option === currentSelectedOptions[index];
        });
      });
      
      if (perfectMatch) return perfectMatch;
      
      // Tercero: buscar variante que mantenga las opciones más importantes (últimas seleccionadas)
      // Priorizar mantener opciones que no sean la primera (color generalmente es la primera)
      const partialMatch = imageVariants.find(variant => {
        let matchScore = 0;
        variant.options.forEach((option, index) => {
          if (currentSelectedOptions[index] === option) {
            // Dar más peso a opciones que no son la primera (ej: talla, prescripción)
            matchScore += index > 0 ? 3 : 1;
          }
        });
        return matchScore > 0;
      });
      
      if (partialMatch) return partialMatch;
      
      // Cuarto: fallback - tomar la primera variante disponible para esta imagen
      return imageVariants[0];
    }

    // Función para actualizar solo las opciones que cambiaron (preservar las que se pueden mantener)
    function updateVariantInputsSelectively(variant, preserveOptions = []) {
      if (!variant) return;

      const allSelects = document.querySelectorAll('select[name*="options"]');
      const allSwatches = document.querySelectorAll('.product__color-swatch');
      const allChips = document.querySelectorAll('.product__chip');

      // Actualizar selects solo si la opción cambió
      allSelects.forEach((select, index) => {
        if (variant.options[index] && !preserveOptions.includes(index)) {
          select.value = variant.options[index];
        }
      });

      // Actualizar swatches (colores)
      allSwatches.forEach(swatch => {
        swatch.classList.remove('selected');
        const swatchValue = swatch.dataset.optionValue;
        if (variant.options.includes(swatchValue)) {
          swatch.classList.add('selected');
        }
      });

      // Actualizar chips 
      allChips.forEach(chip => {
        chip.classList.remove('selected');
        const chipValue = chip.dataset.optionValue;
        if (variant.options.includes(chipValue)) {
          chip.classList.add('selected');
        }
      });

      // Actualizar etiquetas de opciones seleccionadas
      const selectedValueElements = document.querySelectorAll('[data-selected-value-for-option]');
      selectedValueElements.forEach(element => {
        const optionName = element.dataset.optionName;
        const optionIndex = parseInt(optionName.replace('option', '')) - 1;
        if (variant.options[optionIndex]) {
          element.textContent = variant.options[optionIndex];
        }
      });
    }

    // Función para actualizar todos los inputs de variantes
    function updateVariantInputs(variant) {
      if (!variant) return;

      const allSelects = document.querySelectorAll('select[name*="options"]');
      const allSwatches = document.querySelectorAll('.product__color-swatch');
      const allChips = document.querySelectorAll('.product__chip');

      // Actualizar selects
      allSelects.forEach((select, index) => {
        if (variant.options[index]) {
          select.value = variant.options[index];
        }
      });

      // Actualizar swatches (colores)
      allSwatches.forEach(swatch => {
        swatch.classList.remove('selected');
        const swatchValue = swatch.dataset.optionValue;
        if (variant.options.includes(swatchValue)) {
          swatch.classList.add('selected');
        }
      });

      // Actualizar chips 
      allChips.forEach(chip => {
        chip.classList.remove('selected');
        const chipValue = chip.dataset.optionValue;
        if (variant.options.includes(chipValue)) {
          chip.classList.add('selected');
        }
      });

      // Actualizar etiquetas de opciones seleccionadas
      const selectedValueElements = document.querySelectorAll('[data-selected-value-for-option]');
      selectedValueElements.forEach(element => {
        const optionName = element.dataset.optionName;
        const optionIndex = parseInt(optionName.replace('option', '')) - 1;
        if (variant.options[optionIndex]) {
          element.textContent = variant.options[optionIndex];
        }
      });
    }

    // Función para verificar si es producto importado
    function isImportedProduct() {
      // Verificar por tags del producto (método más confiable)
      const productContainer = document.querySelector('[data-section-type="product"]');
      if (productContainer) {
        const productTags = productContainer.dataset.productTags;
        if (productTags && productTags.includes('importacion')) return true;
      }

      // Verificar por colección como fallback
      const collectionElements = document.querySelectorAll('[data-collection-handle]');
      for (let el of collectionElements) {
        if (el.dataset.collectionHandle === 'productos-importados') return true;
      }

      // Verificar por handle del producto
      if (currentProduct && currentProduct.handle && 
          currentProduct.handle.includes('import')) return true;
      
      return false;
    }

    // Función para actualizar precios (incluyendo lógica de productos importados)
    function updateProductPrice(variant) {
      const priceElements = document.querySelectorAll('[data-price]');
      const comparePriceElements = document.querySelectorAll('[data-compare-price]');
      
      if (!variant) return;

      // Para productos importados, verificar si deben mostrar rango
      if (isImportedProduct()) {
        const allPrices = variants.filter(v => v.available).map(v => v.price);
        const minPrice = Math.min(...allPrices);
        const maxPrice = Math.max(...allPrices);
        
        // Si hay variación de precios significativa, mostrar rango
        if (minPrice !== maxPrice && (maxPrice - minPrice) > (minPrice * 0.1)) {
          priceElements.forEach(el => {
            el.innerHTML = `Desde ${formatPrice(minPrice)} - ${formatPrice(maxPrice)}`;
          });
          
          // Ocultar precio de comparación para rangos
          comparePriceElements.forEach(el => {
            el.style.display = 'none';
          });
          
          return;
        }
      }

      // Precio normal para variante específica
      priceElements.forEach(el => {
        el.textContent = formatPrice(variant.price);
      });
      
      // Precio de comparación
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceElements.forEach(el => {
          el.textContent = formatPrice(variant.compare_at_price);
          el.style.display = '';
        });
      } else {
        comparePriceElements.forEach(el => {
          el.style.display = 'none';
        });
      }

      // Actualizar badges de descuento
      const discountElements = document.querySelectorAll('[data-discount], .sale');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        discountElements.forEach(el => el.style.display = '');
      } else {
        discountElements.forEach(el => el.style.display = 'none');
      }

      // Actualizar elementos BSS B2B si existen
      const bssElements = document.querySelectorAll('[bss-b2b-variant-id]');
      bssElements.forEach(el => {
        el.setAttribute('bss-b2b-variant-id', variant.id);
      });
    }

    // Función para sincronizar imagen activa
    function updateActiveMedia(variant) {
      if (!variant || !variant.featured_media) return;

      const mediaElements = document.querySelectorAll('[data-media-item-id]');
      const targetMedia = document.querySelector(`[data-media-item-id="${variant.featured_media.id}"]`);
      
      // Remover clase activa de todas las imágenes
      mediaElements.forEach(el => {
        el.classList.remove('active', 'selected');
        el.removeAttribute('data-active');
      });
      
      // Añadir clase activa a la imagen correspondiente
      if (targetMedia) {
        targetMedia.classList.add('active', 'selected');
        targetMedia.setAttribute('data-active', 'true');
        
        // Si está en un slider, hacer scroll hasta la imagen
        if (targetMedia.dataset.slideIndex) {
          const slider = targetMedia.closest('[data-scroller-id]');
          if (slider) {
            const slideIndex = parseInt(targetMedia.dataset.slideIndex);
            // Activar slide usando el sistema de slider del tema
            const event = new CustomEvent('slider:change', {
              detail: { index: slideIndex }
            });
            slider.dispatchEvent(event);
          }
        }
      }
    }

    // Handler principal para actualización completa
    function handleVariantChange(variant, source = 'unknown') {
      if (!variant) return;
      
      console.log(`Variant change from ${source}:`, variant);
      
      updateVariantInputs(variant);
      updateProductPrice(variant);
      updateActiveMedia(variant);
      
      // Actualizar hidden inputs de formulario si existen
      const variantIdInput = document.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      
      // Disparar evento personalizado para otros componentes
      const event = new CustomEvent('product:variant-change', {
        detail: { variant: variant, source: source },
        bubbles: true
      });
      document.dispatchEvent(event);
    }

    // Handler específico para clics en galería (respeta opciones seleccionadas)
    function handleImageGalleryClick(variant, source = 'gallery-click') {
      if (!variant) return;
      
      console.log(`Gallery click from ${source}:`, variant);
      
      // Solo actualizar precio e imagen, mantener inputs como están si es posible
      updateProductPrice(variant);
      updateActiveMedia(variant);
      
      // Actualizar hidden inputs de formulario
      const variantIdInput = document.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      
      // Solo actualizar inputs si realmente cambió la variante seleccionada
      const currentVariant = findVariantByOptions();
      if (!currentVariant || currentVariant.id !== variant.id) {
        updateVariantInputsSelectively(variant);
      }
      
      // Disparar evento personalizado
      const event = new CustomEvent('product:variant-change', {
        detail: { variant: variant, source: source },
        bubbles: true
      });
      document.dispatchEvent(event);
    }

    // Escuchar clics en imágenes del producto (modo inteligente que respeta opciones)
    document.addEventListener('click', function(e) {
      const mediaWrapper = e.target.closest('[data-product-media-wrapper]');
      if (!mediaWrapper) return;
      
      const imageEl = e.target.tagName === 'IMG' ? e.target : mediaWrapper.querySelector('img');
      
      if (imageEl) {
        // Usar función inteligente que respeta opciones seleccionadas
        const compatibleVariant = findCompatibleVariantForImage(imageEl.src);
        if (compatibleVariant) {
          handleImageGalleryClick(compatibleVariant, 'gallery-image-click');
        } else {
          // Fallback: usar la función original si no hay variante compatible
          const fallbackVariant = findVariantByImage(imageEl.src);
          if (fallbackVariant) {
            handleVariantChange(fallbackVariant, 'image-click-fallback');
          }
        }
      }
    });

    // Escuchar cambios en selects de variantes
    document.addEventListener('change', function(e) {
      if (e.target.matches('select[name*="options"]')) {
        const variant = findVariantByOptions();
        if (variant) {
          handleVariantChange(variant, 'select-change');
        }
      }
    });

    // Escuchar clics en swatches y chips
    document.addEventListener('click', function(e) {
      if (e.target.matches('.product__color-swatch, .product__chip')) {
        e.preventDefault();
        
        // Actualizar el select correspondiente
        const optionValue = e.target.dataset.optionValue;
        const parentWrap = e.target.closest('[data-index]');
        
        if (parentWrap && optionValue) {
          const selectEl = parentWrap.querySelector('select');
          if (selectEl) {
            selectEl.value = optionValue;
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    // Escuchar eventos del sistema de slider para sincronizar variantes (modo inteligente)
    document.addEventListener('slider:change', function(e) {
      const slide = e.target.querySelector(`[data-slide-index="${e.detail.index}"]`);
      if (slide && slide.dataset.mediaItemId) {
        const imageEl = slide.querySelector('img');
        if (imageEl) {
          // Usar función inteligente que respeta opciones seleccionadas
          const compatibleVariant = findCompatibleVariantForImage(imageEl.src);
          if (compatibleVariant) {
            handleImageGalleryClick(compatibleVariant, 'slider-change');
          } else {
            // Fallback: usar función original si no hay variante compatible
            const fallbackVariant = findVariantByImage(imageEl.src);
            if (fallbackVariant) {
              handleVariantChange(fallbackVariant, 'slider-change-fallback');
            }
          }
        }
      }
    });

    // Inicialización - establecer variante inicial
    const initialVariant = findVariantByOptions();
    if (initialVariant) {
      updateProductPrice(initialVariant);
      updateActiveMedia(initialVariant);
    } else {
      // Si no hay variante seleccionada, usar la primera disponible
      const firstAvailableVariant = variants.find(v => v.available);
      if (firstAvailableVariant) {
        handleVariantChange(firstAvailableVariant, 'initialization');
      }
    }

    // Debug: añadir información al console
    if (window.location.search.includes('debug=variants')) {
      console.log('Variant sync system loaded:', {
        variants: variants.length,
        isImported: isImportedProduct(),
        currentProduct: currentProduct
      });
    }

  });

})();